import { Client } from './client';
import { Workflow } from './workflow';
import { User } from './user';

export class MigrationProcessing {
  id?: string;
  clientId?: string;
  client?: Client;
  metaDataFilePath?: string;
  applicationDataFilePath?: string;
  migratedWorkflowId?: string;
  sourceSystem?: string;
  jurisdiction?: string;
  workflowType?: string; // Workflow type: Permit, Renewable, ContractorRegistration, etc.
  expirationFormula?: string; // Expiration formula for Renewable workflows
  isComplete?: boolean;
  createdBy?: string;
  createdOn?: Date;
  startedBy?: string;
  startedOn?: Date;
  currentOwnerId?: string;
  currentOwner?: User;
  migrationProcessingNotes?: MigrationProcessingNote[];
  migrationExecutions?: MigrationExecution[];
  modifiedBy?: string;
  modifiedOn?: Date;
  workflowMigratedBy?: string;
  workflowMigratedOn?: Date;
  applicationDataMigratedBy?: string;
  applicationDataMigratedOn?: Date;
  completedBy?: string;
  completedOn?: Date;
  deletedBy?: string;
  deletedOn?: Date;

  constructor(init?: Partial<MigrationProcessing>) {
    Object.assign(this, init);
  }
}

export class MigrationProcessingNote {
  id?: string;
  migrationProcessingId?: string;
  migrationProcessing?: MigrationProcessing;
  note?: string;
  createdBy?: string;
  createdOn?: Date;

  constructor(init?: Partial<MigrationProcessingNote>) {
    Object.assign(this, init);
  }
}

export class MigrationProcessingSearchRequest {
  clientId?: string;
  searchTerm?: string;
  sourceSystem?: string;
  jurisdiction?: string;
  workflowType?: string;
  isComplete?: boolean;
  includeDeleted?: boolean;
  currentOwnerId?: string;
  createdAfter?: Date;
  createdBefore?: Date;
  completedAfter?: Date;
  completedBefore?: Date;
  pageNumber?: number;
  pageSize?: number;
  includeCompletedOlderThanWeek?: boolean;

  constructor(init?: Partial<MigrationProcessingSearchRequest>) {
    Object.assign(this, init);
  }
}

export class MigrationProcessingSearchResponse {
  migrationProcessings: MigrationProcessing[] = [];
  recordCount = 0;
  pageCount = 0;
  pageNumber = 0;
  pageSize = 10;

  constructor(init?: Partial<MigrationProcessingSearchResponse>) {
    Object.assign(this, init);
    this.migrationProcessings = (init?.migrationProcessings || []).map(
      processing => new MigrationProcessing(processing)
    );
  }
}

export class MigrationExecution {
  id?: string;
  migrationProcessingId?: string;
  migrationProcessing?: MigrationProcessing;
  templateWorkflowId?: string;
  templateWorkflow?: Workflow;
  targetClientId?: string;
  targetClient?: Client;
  resultWorkflowId?: string;
  executedBy?: string;
  executedOn?: Date;
  csvDataFilePath?: string;
  executionErrors?: string;

  constructor(init?: Partial<MigrationExecution>) {
    Object.assign(this, init);
  }
}

export class MigrationApplicationHistory {
  id?: string;
  migrationProcessingId?: string;
  migrationProcessing?: MigrationProcessing;
  workflowApplicationId?: string;
  applicationIdentifier?: string;
  applicationDataFilePath?: string;
  migratedBy?: string;
  migratedOn?: Date;

  constructor(init?: Partial<MigrationApplicationHistory>) {
    Object.assign(this, init);
  }
}

export class ScheduledTaskQueueItem {
  id?: string;
  parentId?: string;
  parentScheduledTime?: Date;
  taskType?: string;
  taskClass?: string;
  dataJSON?: string;
  results?: string;
  errorMessage?: string;
  queuedOn?: Date;
  executedOn?: Date;
  completedOn?: Date;

  constructor(init?: Partial<ScheduledTaskQueueItem>) {
    Object.assign(this, init);
  }
}

export class ApplicationDataValidationResult {
  isValid?: boolean;
  recordCount?: number;
  errors?: string[];
  matchedProperties?: string[];
  unmatchedProperties?: string[];
  missingRequiredProperties?: string[];

  constructor(init?: Partial<ApplicationDataValidationResult>) {
    Object.assign(this, init);
  }
}
